import { render, staticRenderFns } from "./AddEnroll.vue?vue&type=template&id=5a596b82&scoped=true&"
import script from "./AddEnroll.vue?vue&type=script&lang=js&"
export * from "./AddEnroll.vue?vue&type=script&lang=js&"
import style0 from "./AddEnroll.vue?vue&type=style&index=0&id=5a596b82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a596b82",
  null
  
)

export default component.exports